import { MedicalCaseProcessedPage } from '../../domain/medical-case/model';

export function buildProcessedDocumentPageAnchors(
  page: MedicalCaseProcessedPage,
  anchoredPageNumbers: Set<number>
): string {
  const pageAnchor = `<span id="doc-page-${page.id}"></span>`;
  const legacyPageAnchor = anchoredPageNumbers.has(page.pageNumber)
    ? ''
    : `<span id="doc-page-${page.pageNumber}"></span>`;

  anchoredPageNumbers.add(page.pageNumber);

  return `${pageAnchor}${legacyPageAnchor}`;
}
